import { useQuery } from "@tanstack/react-query";
import type { ProjectPulse } from "@/api/project-pulse";
import { apiFetch } from "@/lib/api";
import { projectPulseKeys } from "@/lib/query";

export type { ProjectPulse };

export function useProjectPulse(projectId: string, enabled = true) {
  return useQuery({
    queryKey: projectPulseKeys.project(projectId),
    queryFn: () => apiFetch<ProjectPulse>(`/projects/${projectId}/pulse`),
    enabled: enabled && !!projectId,
  });
}
